$(function() {

	// Email validation
	$.validator.methods.email = function(value, element, param) {
	    return validateEmail(value);
	}

	// Validate email
	function validateEmail(email) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	}

	// Password
	$.validator.addMethod('strongPassword', function (value, element) {
		if (!value) return true;
		var re = new RegExp(window.serendis.passwordRegex);
		return value.length >= window.serendis.passwordMinLength && re.test(value);
	}, window.serendis.passwordMessage);

	// Not empty
	$.validator.addMethod('notempty', function(value, element) {
	    return !!$.trim(value);
	}, 'This field is required.');

	// Equals
	$.validator.addMethod('equals', function(value, element, params) {
	    return value == params;
	}, 'The answer is incorrect.');

	// Validate
	$('form.validate').validate({
		ignore:':hidden:not(".multiselect, .block input")',
		messages: {
			'ethnicity_ids[]': {
				maxlength: "Please select up to {0}."
			}
		},
		errorPlacement: function($error, $element) {
			if ($element.attr('equals')) return true;
			if ($element.parents('.block').length) {
				$element.parents('.block').append($error);
			}
			else {
				$element.parents('.form-group').append($error);
			}
		}
	});

});